import { Link } from "react-router-dom";
import { MapPin, Phone, Instagram, Youtube } from "lucide-react";
import { Brand } from "@/components/Navbar";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#0B0D15]">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-3 lg:px-12">
      <div className="space-y-4">
        <Brand />
        <p className="max-w-xs text-sm leading-relaxed text-slate-400">
          Captiva Chevy Club Chapter Jawa Timur. Persaudaraan, petualangan, dan kebanggaan otomotif sejak 2014.
        </p>
        <div className="flex gap-3">
          <a data-testid="footer-instagram-link" href="https://instagram.com" target="_blank" rel="noreferrer"
            className="grid h-9 w-9 place-items-center rounded-md border border-white/10 text-slate-400 transition-colors hover:border-rose-500/40 hover:text-rose-400">
            <Instagram className="h-4 w-4" />
          </a>
          <a data-testid="footer-youtube-link" href="https://youtube.com" target="_blank" rel="noreferrer"
            className="grid h-9 w-9 place-items-center rounded-md border border-white/10 text-slate-400 transition-colors hover:border-rose-500/40 hover:text-rose-400">
            <Youtube className="h-4 w-4" />
          </a>
        </div>
      </div>
      <div className="space-y-3">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-rose-400">Sekretariat</p>
        <p className="flex items-start gap-2 text-sm text-slate-300">
          <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-rose-500" />
          Surabaya, Jawa Timur
        </p>
        <p className="flex items-center gap-2 text-sm text-slate-300">
          <Phone className="h-4 w-4 shrink-0 text-rose-500" />
          Hotline WhatsApp: 
        </p>
      </div>
      <div className="space-y-3">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-rose-400">Navigasi</p>
        <div className="grid grid-cols-2 gap-2 text-sm">
          {[["/", "Beranda"], ["/berita", "Berita"], ["/event", "Event"], ["/galeri", "Galeri"], ["/gabung", "Pendaftaran"], ["/admin/login", "Login Pengurus"]].map(([to, label]) => (
            <Link key={to} to={to} data-testid={`footer-link-${label.toLowerCase().replace(" ", "-")}`} className="text-slate-400 transition-colors hover:text-rose-400">
              {label}
            </Link>
          ))}
        </div>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500">
      © 2026 3C-JATIM — Captiva Chevy Club Chapter Jawa Timur. Bagian dari 3C Indonesia (est. 2009).
    </div>
  </footer>
);
